export default __webpack_public_path__ + "static/media/dark.6fbf7385.gif";